export default {
    codeUrl: 'visitor/sendcode',
    loginUrl: 'visitor/visitorlogin',
    getShowdetailsidUrl: 'showdetails/getshowdetailbyshowdetailsid',
    getInfoByLink: 'ShowDetails/getregisterpagesbyshowdetailsid',
    getUserInfo: 'visitor/getpersonal',
    stepUrl: 'showdetails/getinformationbyurlink',
    stepContentUrl: 'ShowDetails/getregisterpagesbyshowdetailsid',
    checkStepOne: 'visitor/addorupdatevisitor',
    questionListUrl: 'visitor/getmysuballanswers',
    questionCommitUrl: 'visitor/updateoraddcatlogs',
    inviteColleaguesUrl: 'visitor/updatecolleagues',
    getconfirmationUrl: 'visitor/getconfirmation',
    getcolleaguesUrl: 'visitor/getcolleagues',
    getconfirmationUrl: 'visitor/getconfirmation',
    checkUserUrl: 'visitor/realname-registration/cbme'
}



// WEBPACK FOOTER //
// ./src/api/urlConfig.js